import {store} from '@/store';
import {userAtom} from '@/store/user';
import {buildMbApiUrl, fetchWithTimeout} from '@/util/request-utils';
import type {Brand} from '@/types/brands';

export async function getBrands(): Promise<Brand[]> {
    const user = store.get(userAtom);
    if (!user?.auth_token) {
        return [];
    }

    const url = buildMbApiUrl('/brands.json', {auth_token: user.auth_token});
    const response = await fetchWithTimeout(url);

    if (!response.ok) {
        return [];
    }

    return response.json();
}
